import React from 'react';

import { useState, useEffect } from 'react';

import makeStyles from '@mui/styles/makeStyles';

import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';


import { ReclamationActionDetailType } from 'constants.js';
import { ReclamationActionDetailCodes } from 'constants.js';


const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%',
        marginBottom: theme.spacing(1)
    },
}));


/* Liste des réponses possibles */
const modeLabel = "Demande d'expertise";
const modes = [
    'Demande à l\'ATC d\'aller sur place',
    'Demande intervention du fournisseur sur place',
];



export default function DemandeExpertiseDialogContent({ onChange, action }) {

    const classes = useStyles();

    const [mode, setMode] = useState('');


    useEffect(() => {
        onChange(null);
    }, [onChange]);



    useEffect(() => {


        const getActionData = () => {

            if (mode === '') {
                return null;
            }


            let actionData =
            {
                code: action.code,
                details: [
                    {
                        code: ReclamationActionDetailCodes.Resultat,
                        type: ReclamationActionDetailType.ChoixSimple,
                        libelle: modeLabel,
                        position: 0,
                        valeurString: modes[mode],
                        valeurInteger: mode
                    }]
            };


            return actionData;
        }


        onChange(getActionData());
    }, [action.code, onChange, mode]);


    return (
        <DialogContent>

            <FormControl component="fieldset" className={classes.formControl}>
                <FormLabel component="legend">{modeLabel}</FormLabel>
                <RadioGroup
                    value={mode.toString()}
                    onChange={e => setMode(parseInt(e.target.value, 10))}
                >
                    {modes.map((m, index) => (
                        <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={m} />
                    ))}

                </RadioGroup>
            </FormControl>

        </DialogContent>
    );
}